<template>
	<div>
		<div class="crumbs">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/classesList' }">
					<i class="el-icon-office-building"></i> 班级管理
				</el-breadcrumb-item>
				<el-breadcrumb-item>添加班级</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="container">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="155px">
				<el-row>
					<el-col :span="24">
						<el-form-item :label="'所属幼儿园'" prop="valueSABSAAI">
							<el-select v-model="ruleForm.valueSABSAAI" clearable filterable :placeholder="'请选择所属幼儿园'" class="handle-select mr10"
							 @change="SABSAAIchange" :disabled="SABSAAIdisabled">
								<el-option v-for="item in ruleForm.optionsSABSAAI" :key="item.SAAMSID" :label="item.SAANAME" :value="item.SAAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'所在年级'" prop="valueSABSADI">
							<el-select v-model="ruleForm.valueSABSADI" clearable filterable :placeholder="'请选择所在年级'" class="handle-select mr10"
							 :disabled="SABSADIdisabled">
								<el-option v-for="item in ruleForm.optionsSABSADI" :key="item.SADMSID" :label="item.SADNAME" :value="item.SADMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item :label="'班级名称'" prop="sabNAME">
							<el-input v-model="ruleForm.sabNAME" :placeholder="'请输入班级名称'" maxlength="50"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="22">
						<el-form-item :label="'关联教室'" prop="valueSABSBAI">
							<el-select v-model="ruleForm.valueSABSBAI" clearable filterable :placeholder="'请选择关联教室'" class="handle-select mr10"
							 :disabled="SABSAEIdisabled">
								<el-option v-for="item in ruleForm.optionsSABSBAI" :key="item.SBAMSID" :label="item.SBANAME" :value="item.SBAMSID">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<div class="submit">
							<el-form-item>
								<el-button @click="goBack()" class="goback">返回</el-button>
								<el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
							</el-form-item>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'addClasses',
		data() {
			//验证字符串
			const validateFontSize = (rule, value, callback) => {
				if (value.toString().length == 0) {
					callback(new Error('请输入班级名称')) //长度在1-20之间
				} else if (value.toString().length < 1 || value.toString().length > 20) {
					callback(new Error('请输入长度在1~20之间的字符')) //长度在1-20之间
				} else {
					this.checkSABNAME(value);
					if (this.isRepeat == true) {
						callback(new Error('班级名称重复'));
					} else {
						callback();
					}
				}
			}
			return {
				web_sphon: sessionStorage.getItem("ms_username"), //web 登录用户ID
				SABSAAIdisabled: false,
				SABSADIdisabled: true,
				SABSAEIdisabled: true,

				isRepeat: false,
				ruleForm: {
					sabNAME: '',
					optionsSABSAAI: [],
					valueSABSAAI: '',
					optionsSABSADI: [],
					valueSABSADI: '',
					optionsSABSBAI: [],
					valueSABSBAI: ''
				},
				rules: {
					sabNAME: [{
						required: true,
						//message: '请输入班级名称', 
						trigger: ['blur', 'change'],
						validator: validateFontSize
					}],
					valueSABSAAI: [{
						required: true,
						message: '请选择所属幼儿园',
						trigger: ['blur', 'change']
					}],
					valueSABSADI: [{
						required: true,
						message: '请选择所在年级',
						trigger: ['blur', 'change']
					}]
				}
			};
		},
		created() {
			this.getSAA(); //获取幼儿园信息
		},
		methods: {
			//验证此幼儿园下，班级名称是否重复
			checkSABNAME(value) {
				const self_shop = this;

				var postUrl = 'WCF/WEB/svcSAB.svc/CHECK_SAB_NAME';
				//网络请求接口
				this.$axios.post(
					//请求的url
					postUrl,
					//请求参数
					{
						sPHON: self_shop.web_sphon, //web侧 登录邮箱
						sSAAID: self_shop.ruleForm.valueSABSAAI,
						sSABID: null,
						sSABNM: value
					}
				)
				.then((response) => {
					//请求成功返回的数据
					if (response.data.KKSTR == "Y") {
						this.isRepeat = true;
					} else {
						this.isRepeat = false;
					}
				})
				.catch((error) => {
					this.$message({
						message: '请求失败', //请求失败
						type: 'error'
					});
				});
			},
			//获取幼儿园信息
			getSAA() {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAA.svc/Get_SAA_GardenList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSABSAAI = response.data.KKDT;
						} else {
							this.ruleForm.optionsSABSAAI = '';
							this.ruleForm.valueSABSAAI = '';
						}
					})
					.catch((error) => {
						this.ruleForm.valueSABSAAI = '';
						this.$message({
							message: '获取幼儿园信息请求失败', //请求失败
							type: 'error'
						});
					});
			},
			//获取年级信息
			getSAD(valueSAAI) {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSAD.svc/GET_SAD_GradeLIST';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAI: valueSAAI //web侧 登录ID  tihs.web_suuid
						}
					)
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSABSADI = response.data.KKDT;
						} else {
							this.ruleForm.optionsSABSADI = '';
							this.ruleForm.valueSABSADI = '';
						}
					})
					.catch((error) => {
						this.ruleForm.valueSABSADI = '';
						this.$message({
							message: '获取年级信息请求失败', //请求失败
							type: 'error'
						});
					});
			},
			getSBA(valueSAAI) {
				const self_agent = this;
				var postUrl = 'WCF/WEB/svcSBA.svc/Get_SBA_ClassRoomList';
				//网络请求接口
				this.$axios.post(
						//请求的url
						postUrl,
						//请求参数
						{
							sPHON: self_agent.web_sphon, //web侧 登录ID  tihs.web_suuid
							sSAAI: valueSAAI
						})
					.then((response) => {
						//请求成功返回的数据
						let resCount = response.data.KKDTCOUNT;
						if (resCount > 0) {
							this.ruleForm.optionsSABSBAI = response.data.KKDT;
						} else {
							this.ruleForm.optionsSABSBAI = '';
							this.ruleForm.valueSABSBAI = '';
						}
					})
					.catch((error) => {
						this.ruleForm.valueSABSBAI = '';
						this.$message({
							message: '获取教室信息请求失败', //请求失败
							type: 'error'
						});

					});
			},

			//班级新增
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						const self = this;
						var postUrl = 'WCF/WEB/svcSAB.svc/ADD_SAB';
						//网络请求接口
						this.$axios.post(
								//请求的url
								postUrl,
								//请求参数
								{
									sPHON: self.web_sphon, //web侧 登录ID  tihs.web_suuid

									sSABNAME: self.ruleForm.sabNAME,
									sSABSAAI: self.ruleForm.valueSABSAAI ? self.ruleForm.valueSABSAAI : '',
									sSABSADI: self.ruleForm.valueSABSADI ? self.ruleForm.valueSABSADI : '',
									sSABSBAI: self.ruleForm.valueSABSBAI ? self.ruleForm.valueSABSBAI : ''
								}
							)
							.then((response) => {
								//请求成功返回的数据
								let resStatus = response.status; //200 代表请求成功
								let resKKSTR = response.data.KKSTR;

								if (resStatus == "200") {
									if (resKKSTR == "N") {
										this.$message({
											message: '添加班级失败', //新增失败
											type: 'error'
										});
									} else if (resKKSTR == "Y") {
										this.$message.success('添加班级成功'); // 新增成功
										this.$router.push('/classesList') // 跳转路由
										this.$bus.$emit('change') //子组件可以使用$emit触发父组件的自定义事件 reload

										var indexs;
										for (let i = 0; i < this.COMM.tagsLists.length; i++) {
											if (this.COMM.tagsLists[i].name == "addClasses") {
												indexs = i;
												break;
											}
										}

										this.closeTags(indexs);
									}
								} else {
									this.$message({
										message: '添加班级请求失败', //请求失败
										type: 'error'
									});
								}
							})
							.catch((error) => {
								this.$message({
									message: '添加班级请求失败', //请求失败
									type: 'error'
								});
							});
					} else {
						this.$message({
							message: '表单验证失败', //表单验证失败
							type: 'error'
						});
					}
				});
			},

			// 关闭单个标签
			closeTags(index) {
				const delItem = this.COMM.tagsLists.splice(index, 1)[0];
				const item = this.COMM.tagsLists[index] ? this.COMM.tagsLists[index] : this.COMM.tagsLists[index - 1];
				if (item) {
					delItem.path === this.$route.fullPath && this.$router.push(item.path);
				} else {
					this.$router.push('/');
				}
			},
			//返回
			goBack() {
				this.$router.go(-1);

				var indexs;
				for (let i = 0; i < this.COMM.tagsLists.length; i++) {
					if (this.COMM.tagsLists[i].name == "addClasses") {
						indexs = i;
						break;
					}
				}

				this.closeTags(indexs);
			},
			// 幼儿园选择事件
			SABSAAIchange() {
				//debugger;
				//console.log(this.ruleForm.valueSABSAAI);

				if (typeof(this.ruleForm.valueSABSAAI) !== 'undefined') {
					this.getSAD(this.ruleForm.valueSABSAAI);
					this.getSBA(this.ruleForm.valueSABSAAI);

					this.SABSADIdisabled = false;
					this.SABSAEIdisabled = false;

					this.ruleForm.valueSABSADI = '';
					this.ruleForm.valueSABSBAI = '';
				} else {
					this.SABSADIdisabled = true;
					this.SABSAEIdisabled = true;
				}
			}

		}

	}
</script>
<style>
	.el-form-item__error {
		font-size: 14px;
		margin-top: 8px;
	}
</style>
<style scoped>
	.submit {
		margin-left: 35%;
	}

	.submit button {
		width: 94px;
		height: 36px;
		font-size: 14px;
	}

	.goback {
		margin-right: 15px;
	}

	.el-row {
		margin-top: 16px;
	}

	.el-input {
		width: 90%;
	}

	.el-input--small .el-input__inner {
		height: 36px;
		line-height: 36px;
		font-size: 14px;
		padding-left: 10px;
	}
</style>
